import styled from 'styled-components'
import Flickity from 'react-flickity-component'
import { irem } from '../../utils'

export const StyledFlickityComponent = styled(Flickity)<{ $hasOverlay?: boolean }>`
  width: 100%;
  position: relative;
  outline: none;

  .flickity-button {
    display: none;

    &:disabled {
      opacity: 0.3;
      cursor: auto;
      pointer-events: none;
    }
  }

  ${props => props.theme.breakpoints.up('sm')} {
    .flickity-button {
        display: none;
    }
  }

  .flickity-viewport {
    overflow: visible;

    &:focus {
      outline: 0 !important;
    }
  }

  .flickity-page-dots {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    padding: 0;
    list-style: none;
    text-align: center;
    line-height: 1;
    margin-top: ${props => props.theme.typography.pxToRem(20)};
    margin-left: ${props => props.theme.typography.pxToRem(-5)};

    ${props => props.theme.breakpoints.up('sm')} {
      margin-top: ${props => props.theme.typography.pxToRem(40)};
      margin-left: 0;
      text-align: left;
      display: none;
    }

    li {
      margin: 0;

      &::before {
        display: none;
      }
    }

    .dot {
      display: inline-block;
      width: ${props => props.theme.typography.pxToRem(9)};
      height: ${props => props.theme.typography.pxToRem(9)};
      margin: 0 ${props => props.theme.typography.pxToRem(8)};
      background: #d9d9d9;
      border-radius: 50%;
      cursor: pointer;

      &.is-selected {
        background: transparent;
        border: 2px solid ${props => props.theme.palette.primary.main};
      }
    }
  }
`